import { apiProxyRequest } from "Api/apiProxyRequest";

import type { DeploymentRequestProps, Deployment } from "./types";

export const loadDeploymentNextRequest = ({
  projectId,
  environmentId,
  verbose
}: DeploymentRequestProps) => {
  const verboseQueryParam = verbose ? `?verbose=true` : "";

  return apiProxyRequest<Deployment>(
    `/projects/${projectId}/environments/${environmentId}/deployments/next${verboseQueryParam}`
  );
};
